<template>
  <div :class="`test-container ${ifCurAnswer ? 'test-container_true' : ifCurAnswer !== null ? 'test-container_false' : ''}`">

    <transition name="fade">

      <div
        class="stars"
        v-show="curAnswer === null"
      ></div>

    </transition>

    <transition name="test-elements">

      <TestElements :ifTrue="ifCurAnswer" v-show="curAnswer !== null"/>

    </transition>

    <div class="questions_container">

      <p class="question-header">ВОПРОС {{curQuestion + 1}}</p>

      <p
        class="question"
        v-html="questions[curQuestion].text"
      ></p>

    </div>

    <div class="card-container">

      <Card
        :clip="clip"
        :question="curQuestion"
        :answer="curAnswer"
        :ifCurAnswer="ifCurAnswer"
        :url="questions[curQuestion].url"
      />

      <transition name="fade-but-m">

        <ButtonModern
          @click="Answer(true)" class="button-modern_true"
          v-show="curAnswer === null"
        />

      </transition>

      <transition name="fade-but-m">

        <ButtonModern
          @click="Answer(false)" class="button-modern_false"
          v-show="curAnswer === null"
        />

      </transition>

    </div>

    <transition :name="ifCurAnswer ? 'bubble_true' : 'bubble_false'">

      <Bubble
        @clipFinished="nextQuestion()"
        @click="nextQuestion()"
        v-show="curAnswer !== null"
        :i="bubblePercent"
        :timeout=timeout
        :answer="ifCurAnswer"
        :class="ifCurAnswer ? 'bubble_true' : 'bubble_false'"
        :text="questions[curQuestion].phrase"
      />

    </transition>
  </div>
</template>

<script>
import { questions } from '../assets/texts.json'
import Bubble from './Bubble.vue'
import Card from './Card.vue'
import ButtonModern from './ButtonModern.vue'
import TestElements from './TestElements.vue'

export default {

  name: 'TestContainer',

  components: {
    Bubble,
    ButtonModern,
    Card,
    TestElements
  },

  data(){

    return {
      bubblePercent: .1,
      curAnswer: null,
      ifCurAnswer: null,
      curQuestion: 0,
      clip: false,
      questions,
      rightAnswers: 0,
      timeout: 0
    }

  },

  methods:{

    Answer(a){

      const vid = document.getElementById('video')
      vid.currentTime = 0

      setTimeout(() => {
        this.bubblePercent = vid.duration ? 1/(vid.duration*2) : .1
        vid.play()
        this.clip = true

      }, 500);

      this.timeout = 3.5

      const int = setInterval(() => {
        this.timeout -= .5

        if (this.timeout === 0) {
          clearInterval(int)
        }

      }, 500);

      this.curAnswer = a

      if (a == this.questions[this.curQuestion].answer) {
        this.ifCurAnswer = true
        this.rightAnswers += 1
      } else {
        this.ifCurAnswer = false
      }


    },

    nextQuestion(){

      const vid = document.getElementById('video')
      vid.pause()

      if (this.curQuestion == 5) {
        this.curAnswer = null

        setTimeout(() => {
          this.$emit('finish', this.rightAnswers)
        }, 250);

        return
      }

      this.curAnswer = null
      this.ifCurAnswer = null

      setTimeout(() => {
        this.curQuestion += 1
        this.$emit('goQuestion', 'view_question', {question_number: this.curQuestion})
        this.clip = false
      }, 600);

    }

  }

}
</script>

<style scoped lang="sass">

.test-container
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  height: 100%
  width: 100%
  left: 0
  position: absolute
  margin-top: 50px
  padding-bottom: 200px

  &_true
    .question
      color: #B0F80C

  &_false
    .question
      color: #D357FF

.questions_container
  animation-name: questions
  animation-duration: .3s
  animation-fill-mode: forwards
  animation-timing-function: ease-out
  animation-iteration-count: 1

@keyframes questions

  0%
    transform: translateY(100px)


  100%
    transform: translateY(0px)

.question
  font-family: "VK Sans Display"
  height: 60px
  display: flex
  flex-direction: column
  justify-content: center
  align-items: center
  color: white
  font-size: 1.6em
  font-weight: 500
  text-align: center
  max-width: 500px
  line-height: 120%
  margin-bottom: 19px
  margin-top: 6px

  &-header
    font-family: "VK Sans Display"
    color: white
    font-size: 1.3em
    line-height: 150%
    font-weight: 300
    text-align: center

.stars
  position: absolute
  top: calc(50% - 250px)
  left: calc(50% - 400px)
  background-image: url(../assets/img/stars.svg)
  width: 174.75px
  height: 282px

// .card-container
//   width: 355px
//   // height: 305px
//   display: flex
//   flex-direction: column
//   justify-content: center
//   align-items: center

@media (max-width: 420px)
  .test-container
    top: calc(50% - 80vw)
    padding-bottom: 10vw
    justify-content: flex-start
    max-height: 150vw

  // .card-container
  //   width: 80vw
    // height: 73.75vw

  .question
    height: 14vw
    font-size: 1.5em
    max-width: 90vw
    margin-top: 0vw
    margin-bottom: 3vw

  .stars
    width: 113vw
    height: 121.25vw
    top: calc(50% - 66vw)
    left: calc(50% - 59vw)
    background-image: url(../assets/img/stars_mobile.svg)

</style>
